import { useState, type FormEvent } from "react";
import { login, registerUser } from "../services/auth";

export default function LoginPage() {
  const [isRegister, setIsRegister] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [identificacion, setIdentificacion] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccessMsg(null);
    setLoading(true);

    try {
      if (isRegister) {
        const response = await registerUser({
          username,
          email,
          password,
          identificacion: identificacion || undefined,
        });
        if (response.status === "success") {
          setSuccessMsg("Registro exitoso. Ahora puedes iniciar sesión.");
          setIsRegister(false);
          setUsername("");
          setEmail("");
          setPassword("");
          setIdentificacion("");
        } else {
          setError(response.message || "Error en el registro");
        }
      } else {
        const tokenData = await login(username, password);
        localStorage.setItem("access_token", tokenData.access);
        localStorage.setItem("refresh_token", tokenData.refresh);
        window.location.reload();
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "Error en la solicitud");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-form-container">
          <div className="login-header">
            <h1 className="login-title">
              {isRegister ? "Crear Cuenta" : "Iniciar Sesión"}
            </h1>
            <p className="login-subtitle">
              {isRegister
                ? "Regístrate para gestionar tus conversaciones"
                : "Accede a tu panel de CRM WhatsApp"}
            </p>
          </div>

          {error && <div className="login-alert login-alert-error">{error}</div>}
          {successMsg && <div className="login-alert login-alert-success">{successMsg}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">Usuario</label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Ingresa tu usuario"
                required
              />
            </div>

            {isRegister && (
              <div className="form-group">
                <label htmlFor="email">Correo Electrónico</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="correo@ejemplo.com"
                  required
                />
              </div>
            )}

            {isRegister && (
              <div className="form-group">
                <label htmlFor="identificacion">Identificación (opcional)</label>
                <input
                  id="identificacion"
                  type="text"
                  value={identificacion}
                  onChange={(e) => setIdentificacion(e.target.value)}
                  placeholder="Cédula o RUC"
                />
              </div>
            )}

            <div className="form-group">
              <label htmlFor="password">
                {isRegister ? "Contraseña" : "Contraseña"}
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingresa tu contraseña"
                required
              />
            </div>

            <button type="submit" className="login-submit" disabled={loading}>
              {loading ? "Procesando..." : isRegister ? "Crear Cuenta" : "Iniciar Sesión"}
            </button>
          </form>

          <div className="login-toggle">
            <span>
              {isRegister ? "¿Ya tienes cuenta?" : "¿No tienes cuenta?"}
            </span>
            <button
              type="button"
              className="toggle-btn"
              onClick={() => {
                setIsRegister(!isRegister);
                setError(null);
                setSuccessMsg(null);
              }}
            >
              {isRegister ? "Inicia Sesión" : "Regístrate"}
            </button>
          </div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-branding">
          <div className="brand-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <h2 className="brand-title">CRM WhatsApp</h2>
          <p className="brand-description">
            Gestión inteligente de conversaciones. Administra chats, contactos y mensajes
            de WhatsApp desde un solo lugar con soporte multi-sesión y análisis en tiempo real.
          </p>
          <div className="brand-features">
            <div className="brand-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span>Chats en tiempo real</span>
            </div>
            <div className="brand-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span>Gestión de contactos</span>
            </div>
            <div className="brand-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span>Múltiples sesiones</span>
            </div>
            <div className="brand-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span>Historial de mensajes</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}